import { z } from "zod";

export const AdaptiveCardItemSchema = z.object({
  id: z.string().uuid(),
  cardType: z.string(),
  cardContent: z.string(),
  name: z.string(),
  ownerAadId: z.string().uuid().nullish(),
});

export type IAdaptiveCardItem = z.infer<typeof AdaptiveCardItemSchema>;